// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-content {
  margin-top: 10px;
  margin-bottom: 70px;
}

.bloc-ations {
  margin-top: 20px;
  margin-bottom: 20px;
}

.content-form {
  margin: 15px auto 50px auto;
  width: 75%;
}

.bloc-bottom {
  width: 75%;
  margin: auto;
}

.danger {
  color: rgb(255, 79, 79);
}

::ng-deep .mat-mdc-text-field-wrapper {
  right: 20px;
  background-color: white !important;
}

::ng-deep .mat-mdc-select-arrow {
  display: none;
}

.separator {
  margin-left: 20px;
  margin-right: 20px;
  width: 870px;
}

::ng-deep .mat-mdc-text-field-wrapper {
  background-color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+document-request/create-request-template/create-request-template.component.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;EACA,mBAAA;AADF;;AAIA;EACE,gBAAA;EACA,mBAAA;AADF;;AAIA;EACE,2BAAA;EACA,UAAA;AADF;;AAIA;EACE,UAAA;EACA,YAAA;AADF;;AAIA;EACE,uBCda;ADaf;;AAGA;EACE,WAAA;EACA,kCAAA;AAAF;;AAEA;EACE,aAAA;AACF;;AACA;EACE,iBAAA;EACA,kBAAA;EACA,YAAA;AAEF;;AAAA;EACE,kCAAA;AAGF","sourcesContent":["@import \"/src/styles/_variables.scss\";\r\n\r\n.page-content {\r\n  margin-top: 10px;\r\n  margin-bottom: 70px;\r\n}\r\n\r\n.bloc-ations {\r\n  margin-top: 20px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.content-form {\r\n  margin: 15px auto 50px auto;\r\n  width: 75%;\r\n}\r\n\r\n.bloc-bottom {\r\n  width: 75%;\r\n  margin: auto;\r\n}\r\n\r\n.danger {\r\n  color: $danger-color;\r\n}\r\n::ng-deep .mat-mdc-text-field-wrapper {\r\n  right: 20px;\r\n  background-color: white !important;\r\n}\r\n::ng-deep .mat-mdc-select-arrow {\r\n  display: none;\r\n}\r\n.separator {\r\n  margin-left: 20px;\r\n  margin-right: 20px;\r\n  width: 870px;\r\n}\r\n::ng-deep .mat-mdc-text-field-wrapper {\r\n  background-color: white !important;\r\n}\r\n","// Général\r\n$content-background-color: white;\r\n$primary-color: #104a64;\r\n$success-color: #badbcc;\r\n$success-text-color: #0f5132;\r\n$error-color: #f5c2c7;\r\n$error-text-color: #842029;\r\n$secondary-color: #e9af51;\r\n$secondary-color-light: #e9af51a1;\r\n$danger-color: rgb(255, 79, 79);\r\n$page-title-size: 2.3rem;\r\n$common-size: 1.05rem;\r\n$background-light: #104a64;\r\n\r\n// Header\r\n$width-logo: 145px;\r\n$filter-logo: brightness(0) invert(1);\r\n$header-height: 70px;\r\n$header-color-bottom-border: #cbd3db;\r\n\r\n// Left menu\r\n$left-menu-text-color: white;\r\n\r\n// GED\r\n$ged-background-hover-color: #e9af5128;\r\n$ged-folder-color: $primary-color;\r\n$ged-file-color: $primary-color;\r\n$ged-folder-color-hover: #0056b3;\r\n$ged-file-color-hover: #0056b3;\r\n\r\n// Data Tree\r\n$data-tree-left-menu-width: 300px;\r\n$data-tree-article-title-font-size: 2.8rem;\r\n$data-tree-highlight-color: $secondary-color;\r\n\r\n// See rooms\r\n$see-rooms-title-size: 1.7rem;\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
